import api from '../_api'

const getNotifications = ({ commit, state, rootState }) => {
  // get orders

  commit('RESET_NOTIFICATIONS')
  commit('NOTIFICATIONS_LOADING')
  api.fetchNotifications(rootState.user.id, state.notificationsPage, state.notificationsPerPage)
    .then((response) => {
      if (response.success) {
        commit('NOTIFICATIONS_UPDATED', response.data)
      } else {
        commit('NOTIFICATIONS_ERROR')
      }
    })
    .catch((err) => {
      console.error(err)
      commit('NOTIFICATIONS_ERROR')
    })
}

const sendSubscription = ({ rootState }, payload) => {
  return new Promise((resolve, reject) => {
    api.subscribeUser(rootState.user.id, payload)
      .then((response) => {
        resolve({
          success: response.success
        })
      })
      .catch((err) => {
        reject(err)
      })
  })
}

const redirectUrl = ({ rootState }, payload) => {
  return new Promise((resolve, reject) => {
    api.getRedirectionUrl(rootState.user.id, payload)
      .then((response) => {
        resolve({
          success: response.success,
          data: response.data
        })
      })
      .catch((err) => {
        reject(err)
      })
  })
}

const unSubscribeUser = ({ rootState }, payload) => {
  return new Promise((resolve, reject) => {
    api.unSubscribe(rootState.user.id, payload)
      .then((response) => {
        resolve({
          success: response.success,
          data: response.data
        })
      })
      .catch((err) => {
        reject(err)
      })
  })
}

const getMoreNotifications = ({ commit, state, rootState }) => {
  commit('NOTIFICATIONS_NEXT_PAGE_LOADING')
  api.fetchNotifications(rootState.user.id, state.notificationsPage, state.notificationsPerPage)
    .then((response) => {
      if (response.success) {
        commit('NOTIFICATIONS_NEXT_PAGE_UPDATED', response.data)
      } else {
        commit('NOTIFICATIONS_NEXT_PAGE_ERROR')
      }
    })
    .catch(() => {
      commit('NOTIFICATIONS_NEXT_PAGE_ERROR')
    })
}

export default{
  getNotifications,
  getMoreNotifications,
  sendSubscription,
  unSubscribeUser,
  redirectUrl
}
